import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  AppDialogComponent,
  AppDialogData,
  AppDialogType,
} from '../../shared/components/app-dialog/app-dialog.component';

@Injectable({ providedIn: 'root' })
export class DialogService {
  constructor(private dialog: MatDialog) {}

  open(data: AppDialogData) {
    return this.dialog.open(AppDialogComponent, {
      width: '420px',
      maxWidth: '95vw',
      panelClass: 'app-dialog-panel',
      data,
    });
  }

  success(title: string, message: string) {
    return this.open({ type: 'success', title, message });
  }

  error(title: string, message: string) {
    return this.open({ type: 'error', title, message });
  }

  info(title: string, message: string) {
    return this.open({ type: 'info', title, message });
  }

  warning(title: string, message: string) {
    return this.open({ type: 'warning', title, message });
  }
}
